import PageHandlersService from '@/utils/page-handlers-service';
import axios from 'axios';

const pageHandlers = new PageHandlersService();

const init = () => {
    const cancelCollapseButtons = document.querySelectorAll<HTMLElement>('.js-ph-collapse-cancel');
    const ordersList = document.querySelector('.main');

    cancelCollapseButtons.forEach((cancelButton) => {
        const orderId = cancelButton.dataset.id;

        if (orderId) {
            const cancelPopup = document.querySelector(`.js-hp-order-cancel-popup[data-id="${orderId}"]`);

            const setIsPopupOpened = (isPopupOpened: boolean) => {
                if (isPopupOpened) {
                    cancelPopup?.classList.add('active');
                } else {
                    cancelPopup?.classList.remove('active');
                }
            };

            pageHandlers.set(cancelButton, () => {
                setIsPopupOpened(true);
            });
            pageHandlers.set(cancelPopup?.querySelector('.js-hp-close'), () => {
                setIsPopupOpened(false);
            });
            pageHandlers.set(cancelPopup?.querySelector('.js-hp-close-bg'), () => {
                setIsPopupOpened(false);
            });

            if (cancelPopup) {
                const form = cancelPopup.querySelector<HTMLFormElement>('.js-order-cancellation-form');
                const reasonInput = cancelPopup.querySelector<HTMLInputElement>('.js-order-cancellation-form-reason');
                const reasonInputGroup = cancelPopup.querySelector<HTMLElement>(
                    '.js-hp-order-cancel-popup-reason-input-group',
                );
                const reasonInputErrorElement = reasonInputGroup?.querySelector('.app-message');

                const handleCancellationError = (errorMessage = 'Что-то пошло не так') => {
                    reasonInputGroup?.classList.add('is-error');

                    if (reasonInputErrorElement) {
                        reasonInputErrorElement.innerHTML = errorMessage;
                    }
                };

                if (form) {
                    pageHandlers.set(
                        form,
                        async (event) => {
                            event.preventDefault();
                            const action = form.getAttribute('action');
                            if (action && reasonInput) {
                                try {
                                    const cancellationResponse = await axios.post(action, {
                                        orderId,
                                        reason: reasonInput.value,
                                    });
                                    if (cancellationResponse.data.success) {
                                        const orderListContent = await axios.get('/personal/order/');

                                        if (ordersList && orderListContent.status === 200) {
                                            ordersList.innerHTML = orderListContent.data;
                                            window.location.reload();
                                        }
                                    } else {
                                        handleCancellationError(cancellationResponse.data.message);
                                    }
                                } catch {
                                    handleCancellationError();
                                }
                            }
                        },
                        'submit',
                    );
                }
            }
        }
    });
};

const destroy = () => {
    pageHandlers.clear();
};

export default { init, destroy };
